/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CheckPauseIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Check Pause',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m23.1 15.343 6.391-8.215a1 1 0 0 0-.175-1.4l-1.459-1.136a1 1 0 0 0-1.4.175L12.822 22.283l-6.647-6.612a1 1 0 0 0-1.414 0L3.437 17a1 1 0 0 0 0 1.415l8.926 8.9a1 1 0 0 0 1.5-.093l.888-1.142A12.294 12.294 0 0 1 23.1 15.343Z"
    />
    <path
      d="M27 18.1a8.9 8.9 0 1 0 8.9 8.9 8.9 8.9 0 0 0-8.9-8.9Zm-1 13.474h-2.632v-9.148H26Zm4.632 0H28v-9.148h2.632Z"
    />
  </svg>`;
};
